import React, { useState } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { getLocalPlayer, getPlayer, getPlayerIDsSorted, getTable } from './roomSlice';
import classNames from "classnames";
import { useTranslation } from 'react-i18next';

import './PlayerList.css';

const PlayerListItemOptions = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const localPlayer = useSelector(getLocalPlayer, shallowEqual);
  const table = useSelector(state => getTable(state, localPlayer.table), shallowEqual);

  const links = [
    <a href={"/user/profile/basic/?userid="+props.id} target="_blank" rel="noopener noreferrer">{t('PROFILE')}</a>
  ];

  if (props.lobby) {
    if (localPlayer.id !== props.id && table !== null && table.hostid === localPlayer.id) {
      links.push(<a onClick={e => { dispatch({ type: 'action/kick', payload: { id: props.id }}); e.preventDefault(); } } href="/" target="_blank">{t('KICK')}</a>);
    } else {
      links.push(<span className="diabled">{t('KICK')}</span>);
    }
  } else {
    if (localPlayer.id !== props.id && table !== null && table.hostid === localPlayer.id && table.players.length < table.numplayers) {
      links.push(<a onClick={e => { dispatch({ type: 'action/invite', payload: { id: props.id }}); e.preventDefault(); } } href="/" target="_blank">{t('INVITE')}</a>);
    } else {
      links.push(<span className="diabled">{t('INVITE')}</span>);
    }
  }

  return (
    <tr>
      <td colSpan="2">
        <div className="links">
          {links.map((link, i) => {
            return (
              <span key={i}>
                {i > 0 && ", "}
                {link}
              </span>
            )
          })}
        </div>
      </td>
    </tr>
  );
}

const PlayerListItem = (props) => {
  const player = useSelector(state => getPlayer(state, props.id), shallowEqual);
  const [showOptions, setShowOptions] = useState(false);

  const cls = classNames({
    playing: player.table !== null,
    mod: player.lvl >= 50 && player.lvl < 100,
    admin: player.lvl >= 100,
  });
  const prefix = ((level) => {
    if (level >= 100) {
      return '@';
    }
    if (level >= 50) {
      return '+';
    }
    return null;
  })(player.lvl);

  const optionElem = (() => {
    if (!showOptions) {
      return null;
    }

    return <PlayerListItemOptions id={player.id} lobby={props.lobby} />;
  })();

  return (
    <tbody onClick={e => { if (e.target.tagName !== 'A') { setShowOptions(!showOptions); e.preventDefault(); } }}>
      <tr className={cls}><td className="player">{prefix}{player.name}</td><td className="rating">{player.rating}</td></tr>
      {optionElem}
    </tbody>
  );
};

export const PlayerList = () => {
  const { t } = useTranslation();
  const playerIDs = useSelector(getPlayerIDsSorted, shallowEqual);

  const players = playerIDs.map((id) => {
    return <PlayerListItem key={id} id={id} lobby={false} />;
  });

  return (
    <>
      <h2>{t("PLAYERS")}</h2>
      <div className="playerListWrapper"><div className="playerList box"><table>{players}</table></div></div>
    </>
  );
};

export const TablePlayerList = (props) => {
  const table = props.table;
  const players = table.players.map((id) => {
    return <PlayerListItem key={id} id={id} lobby={true} />;
  });

  return <div className="playerList"><table>{players}</table></div>;
};